import { renderIcon } from '../../SvgIcon.esm.js';

/******************************************************
 * This file was created by scripts/generate.js as part
 * of the build process. Do not edit this file directly.
 ******************************************************/
var iconType = {
  viewBox: "0 -960 960 960",
  paths: [{
    d: "M200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v560q0 33-23.5 56.5T760-120H200zm240-240H200v160h240v-160zm80 0v160h240v-160H520zm-80-80v-160H200v160h240zm80 0h240v-160H520v160zM200-680h560v-80H200v80z"
  }],
  circles: []
};
var TableIcon = function TableIcon(props) {
  return renderIcon(props, iconType);
};

export { TableIcon };
//# sourceMappingURL=TableIcon.esm.js.map
